// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/briefcase-medical.js';

import { paths } from '../generated/briefcase-medical';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('briefcase-medical', Original, paths);
